var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11532_4020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.956288 10.7767L3.1669 11.5273V17.2643C3.1669 17.4055 3.21012 17.5433 3.29053 17.6583C3.37094 17.7734 3.48456 17.86 3.61555 17.9062L12.2767 20.9608C12.4136 21.0104 12.5628 21.013 12.7013 20.9683L12.7107 20.9655L12.7207 20.9621L21.3844 17.9062C21.5154 17.86 21.6291 17.7734 21.7095 17.6583C21.7899 17.5433 21.8331 17.4055 21.8331 17.2643V11.5273L24.0437 10.7767C24.1457 10.7422 24.2379 10.683 24.3126 10.6043C24.3873 10.5256 24.4422 10.4297 24.4727 10.3246C24.5031 10.2196 24.5082 10.1087 24.4875 10.0013C24.4668 9.89381 24.4209 9.79307 24.3537 9.7076L21.6871 6.31134C21.608 6.21101 21.5026 6.13563 21.3831 6.09398L12.718 3.03734C12.5768 2.98755 12.4232 2.98755 12.282 3.03734L3.61689 6.09398C3.4974 6.13563 3.39197 6.21101 3.3129 6.31134L0.646295 9.7076C0.579122 9.79307 0.533222 9.89381 0.512505 10.0013C0.491789 10.1087 0.49687 10.2196 0.527316 10.3246C0.557762 10.4297 0.61267 10.5256 0.687362 10.6043C0.762055 10.683 0.854317 10.7422 0.956288 10.7767ZM10.7127 13.578L11.8334 11.9478V19.3673L4.5002 16.7807V11.9797L9.95606 13.8327C10.0924 13.8789 10.2396 13.8789 10.376 13.8329C10.5123 13.7869 10.6304 13.6979 10.7127 13.578ZM5.8715 6.73587L12.5 9.07386L19.1285 6.73587L12.5 4.39789L5.8715 6.73587ZM14.2873 13.5787L13.1666 11.9471V19.3673L20.4998 16.7807V11.9797L15.0439 13.8327C14.9076 13.8789 14.7604 13.8789 14.624 13.8329C14.4877 13.7869 14.3696 13.6972 14.2873 13.5773M4.06021 7.53467L2.28492 9.79591L5.95883 11.0437L9.9054 12.3839L11.4474 10.1403L11.3574 10.1084L4.06021 7.53467ZM22.7151 9.79591L20.9398 7.53399L13.5526 10.1403L15.0946 12.3839L22.7151 9.79591Z",
    fill: "#FCFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11532_4020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/Stock.733d945cfd7980a4ff76231ae7e1927f.svg";
export { ForwardRef as ReactComponent };